import React from 'react'
import { IProps } from './index'
import classnames from 'classnames'
import { TextLink } from 'marketing-site/src/library/elements/TextLink'
import { Text } from 'marketing-site/src/library/elements/Text'
import { HeaderNavigationLinkBadge } from 'marketing-site/src/library/components/HeaderNavigationGrid/headerNavigationLinkBadge'

export const SubNavItem: React.FC<IProps> = ({ title, badge, url, isActive = false }) => {
  const titleClasses = classnames('sub-nav-item__title', {
    'sub-nav-item__title--active': isActive,
  })

  return (
    <>
      <div className="sub-nav-item" data-testid="sub-nav-item">
        <div className={titleClasses} data-testid="menu-item">
          <TextLink url={url} newWindow={false}>
            <Text size="body-bold">{title}</Text>
          </TextLink>
        </div>
        {badge && <HeaderNavigationLinkBadge {...badge} />}
      </div>
      <style jsx>
        {`
          .sub-nav-item {
            display: flex;
            gap: 0.25rem;

            &__title {
              color: var(--neutral-500);
              transition: color 0.24s;

              &--active,
              &:hover {
                color: var(--mvp-slate);
              }

              :global(a) {
                border: none;
              }

              :global(span) {
                cursor: pointer;
                text-decoration: none;
              }
            }

            :global(.badge) {
              margin-left: 0;
            }
          }
        `}
      </style>
    </>
  )
}
